module.exports = __webpack_public_path__ + "static/img/ydh1-price.74d8960d.png";